export default __webpack_public_path__ + "static/media/NL.7595bddf.svg";